import { API_URL } from '../../../../../actions/utilAction';
import { actionCreator,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  extractDataFromObject,
  jsonApiHeader,
  showSuccessMessage,
  createSearchUrlForCustomAPI,
} from '../../../../../actions/utilAction';

export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showSuccessMessage,
  extractDataFromObject,
  API_URL,
  createSearchUrlForCustomAPI,
};

export const POST_AGENCYDATA = `${API_URL}/api/Organization/SaveOrganization`;
export const GET_AGENCYDATABYID = `${API_URL}/api/Organization/GetOrganizationById`;
export const GET_AGENCYLIST = `${API_URL}/api/Organization/GetOrganizations`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const CHECK_AGENCYEXIST = `${API_URL}/api/Organization/CheckOrganizationBusinessName`;

export const AgencyActionTypes = {
  get_master_data: createRequestActionTypes('GET_MASTER_DATA'),
  get_Agency_BySeachText: createRequestActionTypes('GET_AGENCY_BYSEARCHTEXT'),
  get_Agency: createRequestActionTypes('GET_AGENCY'),
  get_Agency_byId: createRequestActionTypes('GET_AGENCY_BYID'),
  post_agency_data: createRequestActionTypes('POST_AGENCY_DATA'),
  delete_agency_data: createRequestActionTypes('delete_AGENCY_DATA'),
  check_agency_name: createRequestActionTypes('CHECK_AGENCY_NAME'),
};
export const MODULE = 'SUPERADMIN_AGENCYSETUP';





// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/ManageAgency/constants/ApiConstants.js